module.exports = __webpack_public_path__ + "assets/FRUIT-OF-WOOD.png";